import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: "root" })
export class HistorialUnidadService {
  constructor(private http: HttpClient) {}

  public getUnidades(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.serverUrl}api/settings/hist/unit/getUnit`
    );
  }

  public getHistorial(
    i: string,
    a: any,
    e: any,
    m: any,
    r: any
  ): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.serverUrl}api/settings/hist/unit/getHist?i=${i}&a=${a}&e=${e}&m=${m}&r=${r}`
    );
  } 

  public downZip(tozip: any): Observable<HttpResponse<Blob>> {
    return this.http.post(`${environment.serverUrl}api/settings/hist/unit/DownZip`, tozip, {
      responseType: "blob",
      observe: "response",
    });
  }
  
  public getPdfActas(i: string): Observable<HttpResponse<Blob>> {
    return this.http.get(`${environment.serverUrl}api/actasadmin/pdf`, {
      params: { i },
      responseType: "blob",
      observe: "response",
    });
  }
  public getPdfRevision(i: string): Observable<HttpResponse<Blob>> {
    return this.http.get(`${environment.serverUrl}api/settings/recepcion/pdf`, {
      params: { i },
      responseType: "blob",
      observe: "response",
    });
  }
  public getPdfMT(i: string): Observable<HttpResponse<Blob>> {
    return this.http.get(`${environment.serverUrl}api/settings/mantenimiento/pdf`, {
      params: { i },
      responseType: "blob",
      observe: "response",
    });
  }
}
